module.exports = __webpack_public_path__ + "static/media/employer.2e2be664.svg";